import { I18n } from 'i18n-js'

declare global {
  interface Window {
    i18n: I18n
  }
}

export const i18n = window.i18n
